module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/147-bangladesh-1b080a163a3416b3b9241d5db2514121.svg";